import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import Highcharts from 'highcharts';

@Component({
  selector: 'app-gdpmsdashboard',
  templateUrl: './gdpmsdashboard.component.html',
  styleUrls: ['./gdpmsdashboard.component.css']
})
export class GdpmsdashboardComponent implements OnInit {

  yearDropDownList: any;
  dgcGraphFilter: object = {'ay':"",'lu':"","month":""};
  statelists: any[];
  monthsList:any = [
    { key: '04' ,value: 'April'},
    { key: '05' ,value:'May'},
    { key: '06' ,value: 'June'},
    { key: '07' ,value:'July'},
    { key: '08' ,value: 'August'},
    { key: '09' ,value:'September'},
    { key: '10' ,value: 'October'},
    { key: '11' ,value:'November'},
    { key: '12' ,value: 'December'},
    { key: '01' ,value:'January'},
    { key: '02' ,value: 'February'},
    { key: '03' ,value:'March'},
  ];
  chartData: any;
  showTwoCharts: boolean;
  lineChartData: any;
  singleColchartData: any;
  showTable: boolean;
  dgcTableData: any;
  isDescending: boolean;

  constructor(
    private submitdataSerivce : SubmitdataService,
    private constants : ConstantsModule
  ) { }

  ngOnInit() {
    this.submitdataSerivce.getassesmentYear();
    this.getdynamicYears();
    this.getstateslist();
    this.setCurrentMonthDefault();
    this.showTwoCharts = true;
    this.showTable = false;
    this.getGraphData();
  }

  getdynamicYears(){
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });
    this.dgcGraphFilter['ay'] = dropDownYear;  
  }

  getstateslist(){
    let postdata = {};
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data =>{
      if(data){
         this.statelists = [];
         Object.keys(data).forEach(key =>{
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        })
      }
    });
  }

  setCurrentMonthDefault(){
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj =>{
      if(monthObj['key']  == currentmonth + 1){
        currentmonthObj = monthObj;
      }
    });
    this.dgcGraphFilter['month'] = currentmonthObj['key'];    
  }

  getGraphData(){
    let postdata = {};
    postdata['ay'] = this.dgcGraphFilter['ay'];
    postdata['subTp'] = ["04","05","06","07","08","09","10","11","12","01","02","03"];

    if(this.showTwoCharts){
      postdata['lu'] = "f78f615d-e270-4f93-90ac-27608e756b85"; //ganga basin uuid
    } else {
      postdata['lu'] = this.dgcGraphFilter['lu'];
    }

    this.submitdataSerivce.dataforReportChart(postdata).subscribe(data =>{
      this.chartData = [];   
      // console.log("data",data['data']);
      this.chartData = data['data'];
      this.formatDataForCharts();
    })    
  }

  formatDataForCharts(){
    let data = this.chartData;
    let subData = [];
    let nonSubData = [];
    this.lineChartData = [];

    if (this.showTwoCharts) {
      Object.keys(data).forEach(obj => {
        if (this.formatMonth(obj) == this.dgcGraphFilter['month']) {
          Object.keys(data[obj]).forEach(state => {
            let subValue = parseInt(data[obj][state]['submitted count'][0]);
            let nonSubValue = parseInt(data[obj][state]['pending count'][0]);
            let item1 = {
              'name' : state,
              'y' : subValue,
              // 'DGCsList' : data[obj][state]['submitted'],
              'type' : 'submitted'
            };
            let item2 = {
              'name' : state,
              'y' : nonSubValue,
              // 'DGCsList' : data[obj][state]['pending'],
              'type' : 'not submitted'
            };
            
            // subData.push([state, subValue,]);
            // nonSubData.push([state, nonSubValue,]);
            subData.push(item1);
            nonSubData.push(item2);
          })
        }
      })
      // console.log("sub & nonsub",subData,nonSubData);
      this.createDoubleColmnChart(subData, nonSubData);

      // Below code for formatting data for Line Chart 
      for (let i = 0; i < this.statelists.length; i++) {
        let arr = [];
        Object.values(data).forEach(month => {
          let subVal = parseInt(month[this.titleCase(this.statelists[i]['name'])]['submitted count'][0]);
          if(subVal != 0){
            arr.push(subVal);
          }
        })
        // console.log("arr",arr);
        this.lineChartData.push(arr);
      }

      this.createLineChart(this.lineChartData);

    } else {
      this.singleColchartData = [];
      Object.keys(data).forEach(mon => {
        Object.values(data[mon]).forEach(state => {
          let percentage = state['percentage'][0];
          let value = parseInt(state['submitted count'][0]);
          let dgcList = this.formatDGCList(state['submitted'],state['pending']);

          let obj = {
            'y' : null,
            'color' : null,
            'DGCsList' : dgcList,
            'month' : this.getMonthName(this.formatMonth(mon))
          }
          let colorvalues;
          if (percentage < 50) {
            colorvalues = 'red';
          } else if (percentage >= 50 && percentage < 100) {
            colorvalues = 'yellow';
          } else if (percentage == 100) {
            colorvalues = 'green';
          } else {
            colorvalues = 'black';
          }

          obj['y'] = value;
          obj['color'] = colorvalues;
          this.singleColchartData.push(obj);
        })
      })

      this.createSingleColmnChart(this.singleColchartData);
    }
  }

  formatDGCList(sub,nonsub){
    let finalList = [];
    // console.log("sub",sub,"nonsub",nonsub);
    let totalList = sub.concat(nonsub);
    let sortedList = totalList.sort();
    sortedList.forEach(arr =>{
      let obj = {};
      if(sub.includes(arr)){
        // console.log("arrsub",arr);
        obj['name'] = arr;
        obj['status'] = 'Submitted';
      } else {
        obj['name'] = arr;
        obj['status'] = 'Pending';
      }
      finalList.push(obj);
    });
    // console.log("finalll",finalList);
    return finalList;
  }

  formatMonth(key){
    let monthKey = key.substring(1,3);
    return monthKey;
  }

  getMonthName(num){
    let date = new Date();
    date.setMonth(num - 1);
    return date.toLocaleString('en-US', { month: 'long' });
  }

  getStateName(stId){
    let stateName;
    this.statelists.forEach(state =>{
      if(state['uuid'] == stId){
        stateName = state['name'];
      }
    })
    return stateName;
  }

  createDoubleColmnChart(subData,nonSubData){   
    // console.log("DC chart",subData,nonSubData);
    let chartTitleEn = "State wise MoMs status for " + this.getMonthName(this.dgcGraphFilter['month']) + " " + this.dgcGraphFilter['ay'];
    Highcharts.chart('double-column-chart', {
      chart:{
        type: 'column'
      },
      title: {
        text: chartTitleEn
      },
      xAxis:{
        // categories: ['Bihar','West Bengal','Uttarakhand','Jharkhand','Uttar Pradesh'],
        type: 'category',
        title: {
          text: 'States',
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        }
      },
      yAxis: {
        title: {
          text: 'No. of DGCs',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
          }
        }
      },
      tooltip: {
        enabled: true,
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name} <b>{point.y}</b></div>`,
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      plotOptions:{
        column: {
          point: {
            events: {
              click: (e) =>{
                // console.log("selected",e.point.options);
                this.drillDownSIngleColChart(e.point.options.name);                
              }
            }
          }
        }
      },
      series: [{
        name: 'Submitted',
        data: subData,
        color: 'green',
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
    {
      name: 'Not submitted',
      data: nonSubData,
      color: 'red',
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '13px',            
          fontFamily: 'Verdana, sans-serif'
        }
      }
    }]
    } as any);
  }

  drillDownSIngleColChart(st){
    // console.log("enetereddd",this.statelists,st);
    let stName = st.toUpperCase();
    this.showTwoCharts = false;
    this.statelists.forEach(state =>{
      if(stName == state['name']){        
        this.dgcGraphFilter['lu'] = state.uuid;
        // console.log("state",stName,state.uuid,state,"aaa",this.dgcGraphFilter['lu']);
      }
    });

    this.getGraphData();
  }

  createLineChart(data){
    // console.log("line data",data);
    let chartTitleEn = "Month wise status of all States for Assessment year " + this.dgcGraphFilter['ay'];
    let xaxislablesEn = ['April','May','June','July','August','September','October','November','December','January','February','March'];
    Highcharts.chart('line-chart', {
      chart:{
        type: 'line'
      },
      title: {
        text: chartTitleEn
      },
      xAxis:{
         categories: xaxislablesEn,
        // type: 'category',
        title: {
          text: 'Months',
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        },
        min: 0,
        max: 11
      },
      yAxis: {
        title: {
          text: 'No. of DGCs submitted',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
         }
        }
      },
      tooltip: {
        enabled: true,
        headerFormat: `<div>{point.key}</div><br>`,
        pointFormat: `<div>{series.name} <b>{point.y}</b></div>`,
        split: true
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      // plotOptions:{
      // },
      series: [{
        name: 'Bihar',
        data: data[0],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: 'Jharkhand',
        data: data[1],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: 'Uttar Pradesh',
        data: data[2],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: 'Uttarakhand',
        data: data[3],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      {
        name: 'West Bengal',
        data: data[4],
        dataLabels: {
          enabled: false,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

  createSingleColmnChart(data){  
    // console.log("single col chart data",data)
    let chartTitleEn = "MoMs status for Assessment year " + this.dgcGraphFilter['ay'] + " - " + this.titleCase(this.getStateName(this.dgcGraphFilter['lu'])) + " State";
    let xaxislablesEn = ['April','May','June','July','August','September','October','November','December','January','February','March'];
    Highcharts.chart('single-column-chart', {
      chart:{
        type: 'column'
      },
      title: {
        text: chartTitleEn
      },
      xAxis:{
        categories: xaxislablesEn,
        // type: 'category',
        title: {
          text: 'Months',
          style: {
            fontSize: '20px',
            color: 'black'
          }          
        },
        labels: {
          style: {
            color: 'black',
            fontSize: '15px'
          }
        }
      },
      yAxis: {
        title: {
          text: 'No. of DGCs submitted',
          style: {
            fontSize: '18px',
            color: 'black'
          }
        },
        labels: {
          style: {
          color: 'black',
          fontSize: '14px'
          }
        }
      },
      tooltip: {
        enabled: false,
        // headerFormat: `<div>{point.key}</div><br>`, 
        // pointFormat: this.selectedlanguage == 'en'?`<div>No. of DGCs submitted: <b>{point.y}</b></div>`: `<div>जमा किए गए डीजीसी की संख्या: <b>{point.y}</b></div>`
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: true,
        useHTML:true,
        labelFormatter: function() {
          let legendEn = '<div>' +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "green" + '; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "Meeting > 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "yellow" + '; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "Meeting 50% to 99%" + "&nbsp&nbsp&nbsp" + "</span>" +
            '<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + "red" + '; display: inline-block; margin-right:5px"></div>' +
            "<span>" + "Meeting 0% to 49.99%" + "</span>" +
            '</div>'
          return legendEn;
        },
          symbolHeight: '0px'
      },
      plotOptions:{
        column: {
          point: {
            events: {
              click: (e) =>{
                // console.log("selected",e.point.options);                
                this.drillDownDGCsTable(e.point.options,);
              }
            }
          }
        }
      },
      exporting : {
        allowHTML: true
      },
      series: [{
        data: data,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '13px',            
            fontFamily: 'Verdana, sans-serif'
          }
        }
      }]
    } as any);
  }

  drillDownDGCsTable(rawdata){
    this.dgcTableData = [];
    this.dgcTableData = rawdata['DGCsList'];
    this.showTable = true;
  }

  titleCase(str){    
    str = str.toLowerCase().split(' ');
    for(var i = 0; i < str.length; i++){
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  sortRows(property){
    this.isDescending = !this.isDescending;
    let direction = this.isDescending ? 1 : -1;

    this.dgcTableData.sort(function(a,b){
    if (a[property] < b[property]) {
      return -1 * direction;
    }
    else if (a[property] > b[property]) {
      return 1 * direction;
    }
    else {
      return 0;
    }
   });
    
  }

}
